<template>
    <v-card class="mx-auto d-flex flex-column"  outlined elevation="1">
                <v-list-item three-line :to="{name: 'site.careers_page.details', params: {slug: career.slug}}" target="_blank">
                    
                    <v-list-item-avatar class="profile" color="" size="90" height="auto" tile>
                        <v-img :src="career.company_logo"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <p class="text-subtitle-2 mb1">
                            {{career.empresa.nome}}
                        </p>
                        <v-list-item-subtitle>
                            {{career.empresa.industria}}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            <!-- <v-col cols="10" style="margin-top: -30px;">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-subtitle>
                            {{career.empresa.nome}}
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-col> -->
    </v-card>
</template>

<script>
export default {
    props: {
        career: {
            required: true,
            type: Object
        }
    }

}
</script>

<style>

</style>